export const cartStyles = {
  control: (base) => ({
    ...base,
    height: 28,
    minHeight: 28,
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '2px 16px 2px 8px',
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: 28,
    minHeight: 28,
  }),
};

export const options = [
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
  { value: 6, label: '6' },
  { value: 7, label: '7' },
  { value: 8, label: '8' },
];
